import React, { useEffect } from 'react';
import { Col, InputNumber, Row } from 'antd';
import Form, { FormInstance } from 'antd/lib/form';

import { ClientFeatureConfig } from '../../../types/Feature';
import { QuoteDenyingConfigAttributes } from '../../../../../server/src/models';

const cardHeaderTitleStyle = { fontSize: '18px' };

interface PackageMaxDimensionsFormSectionProps {
    isDetailMode: boolean;
    formInstance: FormInstance;
    packageMaxDimensionsConfig?: ClientFeatureConfig<QuoteDenyingConfigAttributes>;
}

const PackageMaxDimensionsFormSection: React.FC<PackageMaxDimensionsFormSectionProps> = (
    props: PackageMaxDimensionsFormSectionProps,
) => {
    const { packageMaxDimensionsConfig: config, formInstance, isDetailMode } = props;

    useEffect(() => {
        if (config) {
            formInstance.setFields([
                {
                    name: ['packageMaxDimensions', 'maxWeight'],
                    value: config.config.maxWeight,
                },
            ]);
        }
    }, [config]);

    return (
        <div className="card border-0" id="package-max-dimensions-section">
            <div className="card-header border-bottom d-flex justify-content-between align-items-center bg-white">
                <p className="m-0 p-0 h5" style={cardHeaderTitleStyle}>
                    Package max dimensions
                </p>
            </div>
            <div className="card-body">
                <Row gutter={24}>
                    <Col span={2} />
                    <Col span={5}>
                        <Form.Item
                            name={['packageMaxDimensions', 'maxWeight']}
                            tooltip={<>Any delivery containing at least one package heavier than this will be denied</>}
                            label="Package max weight (kg)"
                        >
                            {isDetailMode ? config?.config.maxWeight : <InputNumber />}
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default PackageMaxDimensionsFormSection;
